// extracted by mini-css-extract-plugin
export default {"resetBtn":"TrayComponents_resetBtn__emX5J"};